import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalWaitTimesByIdInput,
  terminalWaitTimesByIdInputSchema,
} from "./shared/terminalWaitTimes.input";
import {
  type TerminalWaitTime,
  terminalWaitTimeSchema,
} from "./shared/terminalWaitTimes.output";

/**
 * Metadata for the fetchTerminalWaitTimesByTerminalId endpoint
 */
export const terminalWaitTimesByTerminalIdMeta = {
  functionName: "fetchTerminalWaitTimesByTerminalId",
  endpoint: "/terminalWaitTimes/{TerminalID}",
  inputSchema: terminalWaitTimesByIdInputSchema,
  outputSchema: terminalWaitTimeSchema,
  sampleParams: { TerminalID: 11 },
  endpointDescription:
    "Get wait time information for a specific terminal by ID.",
} satisfies EndpointMeta<TerminalWaitTimesByIdInput, TerminalWaitTime>;

/**
 * Fetch function for retrieving wait time information for a specific terminal by ID
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalWaitTimesByIdInput,
  TerminalWaitTime
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalWaitTimesByTerminalIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalWaitTimes.endpoints").terminalWaitTimesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving wait time information for a specific terminal by ID
 */
export const fetchTerminalWaitTimesByTerminalId: FetchFactory<
  TerminalWaitTimesByIdInput,
  TerminalWaitTime
> = fetch;

/**
 * React Query hook for retrieving wait time information for a specific terminal by ID
 */
export const useTerminalWaitTimesByTerminalId: HookFactory<
  TerminalWaitTimesByIdInput,
  TerminalWaitTime
> = useHook;
